import {
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__REQUEST:
    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__SUCCESS:
      return null;

    case ACTION_LOAD_AFFILIATE_TOOLS_FILTER_STRUCTURE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
